import { GeneralLocaleTypes } from '../locales.types'

const generalLocaleNn: GeneralLocaleTypes = {
  username: 'Brukarnamn',
  imageAlt: {},
  status: {
    error: {
      somethingWentWrong: 'Hmm... Noe gjekk gale!',
      sessionError: 'Kan ikke bekrefte økten, prøv igjen senere...'
    }
  },
  actions: {
    back: 'Tilbake',
    cancel: 'Avbryt',
    moveOn: 'Gå vidare',
    remove: 'Fjern',
    next: 'Neste',
    save: 'Lagre {{ addOn }}',
    update: 'Oppdater {{ addOn }}',
    select: 'Velg',
    confirm: 'Bekreft',
    close: 'Lukk',
    revoke: 'Fjern',
    edit: 'Rediger',
    delete: 'Slett'
  },
  or: 'Eller'
}

export default generalLocaleNn
